import $ from 'jquery'
import { z } from 'zod'

export const Item = z.object({
  parent_id: z.string(),
  handle: z.string()
})
export const Input = z.array(Item)

export const Swatch = z.object({
  title: z.string().nullable(),
  handle: z.string().nullable(),
  finish: z.string().nullable(),
  url: z.string().nullable(),
  price: z.string().nullable(),
  type: z.string().nullable(),
  src: z.string().nullable().optional()
})
export type Swatch = z.infer<typeof Swatch>

export const SwatchData = z.object({
  swatches: z.array(Swatch)
})
export type SwatchData = z.infer<typeof SwatchData>

// TODO Avoid using ephemeral CDN image URLs — pass fresh URLs from Liquid
const swatchesImages = [
  {
    name: 'Black',
    src: 'https://cdn.shopify.com/s/files/1/0622/6817/8611/files/swatch-metal-black.jpg?v=1663762976'
  },
  {
    name: 'Champagne Bronze',
    src: 'https://cdn.shopify.com/s/files/1/0622/6817/8611/files/swatch-metal-champagne-bronze.jpg?v=1663763006'
  },
  {
    name: 'Gray',
    src: 'https://cdn.shopify.com/s/files/1/0622/6817/8611/files/swatch-metal-gray.jpg?v=1663763030'
  },
  {
    name: 'Oil Rubbed Bronze',
    src: 'https://cdn.shopify.com/s/files/1/0622/6817/8611/files/swatch-metal-oil-rubbed-bronze.jpg?v=1663763047'
  },
  {
    name: 'Satin Nickel',
    src: 'https://cdn.shopify.com/s/files/1/0622/6817/8611/files/swatch-metal-satin-nickel.jpg?v=1663763119'
  },
  {
    name: 'Silver',
    src: 'https://cdn.shopify.com/s/files/1/0622/6817/8611/files/swatch-metal-silver.jpg?v=1663763157'
  },
  {
    name: 'Sun Gold',
    src: 'https://cdn.shopify.com/s/files/1/0622/6817/8611/files/swatch-metal-sungold.jpg?v=1663763179'
  },
  {
    name: 'White',
    src: 'https://cdn.shopify.com/s/files/1/0622/6817/8611/files/swatch-metal-white.jpg?v=1663763196'
  }
] as const

export const init = async function () {
  const dataItem = document.getElementById('featured-product-data')
  const result = Input.safeParse(JSON.parse(dataItem?.innerText || '[]'))

  if (result.success === false) {
    console.warn(
      'Featured product input is invalid [cbaa045b78d744ccad675965112ad8fc]',
      result.error
    )
    return null
  }

  result.data.forEach((item) => {
    const url = `/collections/all/parent_id:${item.parent_id}?view=swatches-json`

    fetch(url)
      .then(async (response) => {
        return SwatchData.parseAsync(await response.json())
      })
      .then((dataJSON): void => {
        const getUniqueObjectsByFinish = (products) => {
          const uniqueFinishes = {}
      
          for (const product of products) { 
              const finish = product.finish.replace(' Cast Aluminum', '')
              .replace(' Aluminum', '')
              .replace(' Cast Iron', '')
              .replace(' Steel', '')
              .replace(' Unfinished', '')
              .replace(' Finished', '')
              .replace('Flush UNF ', '')
              .replace(' Open', '')
              .replace(' Grille', '')
              .replace('Unfinished ', '')
              .replace('Finished ', '')
      
              const price = parseFloat(product['price'].replace(',', ''))
      
              if (isNaN(price)) {
                  continue
              }
      
              // If current finish is not in uniqueFinishes object or if price of current object is lower then update object
              if (!uniqueFinishes[finish] || price < uniqueFinishes[finish].price) {
                  uniqueFinishes[finish] = {
                    title: product.title,
                    handle: product.handle,
                    finish: finish,
                    url: product.url,
                    price: price,
                    type: product.type
                  }
              }
          }
      
          const uniqueObjects = Object.values(uniqueFinishes)
          return uniqueObjects
        }
      
        const uniqData = getUniqueObjectsByFinish(dataJSON.swatches)
      
        uniqData.map((item) => {
          swatchesImages.map((swatch) => {
            if (item.finish === swatch.name) {
              item['src'] = swatch.src
            }
          })
        })

        $('#js-fp-' + item.handle).append(
          uniqData.length + ` Color${uniqData.length > 1 ? 's' : ''}`
        )

        const html: string = uniqData
          .map((element) => {
            return (
              `<a href="/products/${element.handle}">
                <img 
                  class="FeaturedProducts-swatch" 
                  src="${element.src}" 
                  alt="${element.handle}" 
                  loading="lazy" 
                />
              </a>`
            )            
          })
          .join('\n')

        $('#js-fp-sw-' + item.handle).append(html)
      })
      .catch((err) => {
        console.warn(
          'Swatch cannot be rendered [f0e38c858d9741c69693c9e3cd9c4489]',
          err
        )
      })
  })
}
